import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { SelectModule } from 'src/app/common-components/entity-select/select/select.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { TooltipModule } from 'src/app/common-components/tooltip/tooltip.module';
import { PromptRegisterHoverPipeModule } from 'src/app/pipes/prompt-register-hover-pipe/prompt-register-hover-pipe.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { PromptRegisterComponent } from './containers/prompt-register.component';
import { PromptRegisterEffects } from './state/prompt-register.effects';
import { promptRegisterFeatureKey, promptRegisterReducer } from './state/prompt-register.reducer';
import { PromptRegisterViewComponent } from './views/prompt-register-view.component';
@NgModule({
   declarations: [PromptRegisterComponent, PromptRegisterViewComponent],
   exports: [PromptRegisterComponent, PromptRegisterViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      SelectModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      MatMenuModule,
      MatSlideToggleModule,
      RegisterModule,
      ScrollingModule,
      EntitySelectModule,
      EffectsModule.forFeature([PromptRegisterEffects]),
      StoreModule.forFeature(promptRegisterFeatureKey, promptRegisterReducer),
      AddSpacesPipeModule,
      PromptRegisterHoverPipeModule,
      TooltipModule,
   ],
})
export class PromptRegisterModule {}
